import { StorageReference } from '@angular/fire/storage';

export class SetFoldersAction {
  public static readonly type = '[Project/Storage/List] SetFoldersAction';
  constructor(public readonly folders: StorageReference[]) {}
}
